function isVariantPreorder(variantId) {
    if (typeof productLevelPreorder !== 'undefined' && productLevelPreorder === true) return true;
    if (typeof templateIsPreorder !== 'undefined' && templateIsPreorder === true) return true;

    const variant = variantData.find(v => v.id == variantId);
    if (!variant) return false;

    if (variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue') return true;

    if (typeof variantPreorderData !== 'undefined') {
        const preorderInfo = variantPreorderData.find(v => v.id == variantId);
        if (preorderInfo && preorderInfo.stockLocation !== null && preorderInfo.stockLocation <= 0) return true;
    }

    return false;
}

class DeployerQuantityBreaks extends HTMLElement {
    constructor() {
        super();
        this.main_product_form =
            document.querySelector('.product-form form[action*="/cart/add"]') ||
            document.querySelector('.product__page form[action*="/cart/add"]') ||
            document.querySelector('.product form[action*="/cart/add"]') ||
            document.querySelector('form[action*="/cart/add"]');

        this.main_product_section_id = this.dataset.sectionId;
        this.show_variant_picker = this.getAttribute('data-show-variant-picker') == 'true' ? true : false;
        this.variantData = variantData;
        this.isInitializing = true;
        if (this.main_product_form === null) return console.error('Deployer: No product form found');

        if (this.main_product_form.querySelector('input[name="id"]') !== null) {
            this.main_product_form.querySelector('input[name="id"]').addEventListener('change', (event) => {
                this.renderDeployerQuantityBreaks(event.target.value);
            });
        } else {
            if (typeof subscribe === 'function') {
                this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                    this.renderDeployerQuantityBreaks(event.data.variant.id);
                });
            } else {
                document.addEventListener('variant:change', (event) => {
                    this.renderDeployerQuantityBreaks(event.detail.variant.id);
                });
            }
        }

        // Override theme.js price and button updates - deployer takes priority
        const productContainer = this.closest('.product-section');
        if (productContainer) {
            productContainer.addEventListener('variantPriceChange', () => {
                setTimeout(() => {
                    const selected = this.getSelectedQuantity();
                    if (selected) this.updatePrice(selected);
                }, 50);
            });
            productContainer.addEventListener('variantChange', () => {
                setTimeout(() => {
                    this.updateAddButtonState();
                }, 50);
            });
        }
    }

    connectedCallback() {
        this.clearFormInputs();

        if (this.show_variant_picker === false) {
            this.updateFormInputs(this.getSelectedQuantity());
            this.updatePrice(this.getSelectedQuantity());
            this.updateAddButtonState();
            this.isInitializing = false;
        } else {
            this.updateFormInputs(this.getSelectedQuantity());
            setTimeout(() => {
                this.initializeAllQuantityBreakPrices();
                this.updatePrice(this.getSelectedQuantity());
                this.updateAddButtonState();
                this.isInitializing = false;
            }, 300);
        }

        if (this.show_variant_picker === false) {
            this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
                quantity_break.addEventListener('click', () => {
                    this.selectQuantity(quantity_break);
                    this.updateFormInputs(quantity_break);
                    this.updateImages(quantity_break);
                });
            });
        } else {
            const variantPickers = this.querySelectorAll('deployer-quantity-break-variant-picker');

            variantPickers.forEach((variantPicker) => {
                variantPicker.addEventListener('variantChange', (event) => {
                    const newVariantId = event.detail.variant.id;
                    variantPicker.dataset.id = newVariantId;
                    this.updateFormInputs(this.getSelectedQuantity());
                    const selected = this.getSelectedQuantity();
                    if (selected) this.updatePrice(selected);
                    this.updateAddButtonState();
                });
            });

            this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
                quantity_break.addEventListener('click', (event) => {
                    this.selectQuantity(quantity_break);
                    if (event.target.type != 'select-one')
                        this.updateImages(quantity_break);
                    setTimeout(() => {
                        this.updateFormInputs(quantity_break);
                        this.updatePrice(quantity_break);
                        this.updateAddButtonState();
                    }, 100);
                });
            });
        }
    }

    updateImages(element) {
        const productContainer = this.closest('.product-section');
        const variantId = element.dataset.variantId;
        const variant = this.variantData.filter((variant) => {
            return variant.id == variantId;
        });
        
        if (this.isInitializing) {
            return;
        }
        
        productContainer.dispatchEvent(new CustomEvent('variantImageChange', {
            detail: {
                variant: variant[0]
            }
        }));
    }

    renderDeployerQuantityBreaks(variant_id) {
        this.classList.add('loading');
        var variant_param = '?variant=' + variant_id + '&';
        if (variant_id === undefined) variant_param = '?';

        fetch(window.location.pathname + variant_param + 'section_id=' + this.main_product_section_id)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                const deployerQuantityBreaksSource = html.querySelector('deployer-quantity-breaks');
                const deployerQuantityBreaksDestination = document.querySelector('deployer-quantity-breaks');

                if (deployerQuantityBreaksSource && deployerQuantityBreaksDestination) {
                    deployerQuantityBreaksDestination.innerHTML = deployerQuantityBreaksSource.innerHTML;
                    deployerQuantityBreaksDestination.connectedCallback();
                    
                    // Réattacher les event listeners du cart drawer après modification du DOM
                    const cartDrawer = document.querySelector('deployer-cart-drawer');
                    if (cartDrawer) {
                        // Retirer les marqueurs pour permettre le ré-attachement
                        this.main_product_form.removeAttribute('data-deployer-cart-attached');
                        const addButton = this.main_product_form.querySelector('[name="add"]');
                        if (addButton) {
                            addButton.removeAttribute('data-deployer-click-attached');
                        }
                        // Réattacher les event listeners (qui gérera le type du bouton)
                        cartDrawer.setProductFormCompatibility(cartDrawer);
                    }
                }
            })
            .then(() => {
                this.classList.remove('loading');
            });
    }

    selectQuantity(quantity_break) {
        if (quantity_break.classList.contains('disabled-quantity-break')) return;
        this.resetSelectedQuantity();
        if (this.show_variant_picker) {
            this.updatePrice(quantity_break);
        }
        quantity_break.classList.add('selected-quantity-break');
    }

    resetSelectedQuantity() {
        this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
            quantity_break.classList.remove('selected-quantity-break');
        });
    }

    updateFormInputs(quantity_break) {
        if (!quantity_break) return;
        this.clearFormInputs();
        const allItemsInputs = this.main_product_form.querySelectorAll('input[name*="items"]');
        if (allItemsInputs.length > 0) {
            allItemsInputs.forEach((input) => input.remove());
        }

        if (this.show_variant_picker === false) {
            const quantityInput = this.main_product_form.querySelector('input[name="quantity"]');
            const quantityValue = quantity_break.getAttribute('data-quantity');

            if (quantityInput) {
                quantityInput.value = quantityValue;
            } else {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'quantity';
                input.value = quantityValue;
                this.main_product_form.appendChild(input);
            }
        } else {
            const variantsPickers = quantity_break.querySelectorAll('deployer-quantity-break-variant-picker');
            if (variantsPickers.length > 0) {
                this.clearVariantInputs();

                variantsPickers.forEach((variantsPicker, index) => {
                    const variantId = variantsPicker.dataset.id;

                    if (index === 0) {
                        const selectElement = this.main_product_form.querySelector('select[name="id"]');
                        if (selectElement) {
                            Array.from(selectElement.options).forEach(option => {
                                option.selected = option.value === variantId;
                            });
                        } else {
                            const mainVariantInput = this.main_product_form.querySelector('input[name="product-id"]') || this.main_product_form.querySelector('input[name="id"]');
                            if (mainVariantInput) {
                                mainVariantInput.value = variantId;
                            }
                        }
                    } else {
                        const idx = index - 1;
                        const idInput = document.createElement('input');
                        idInput.type = 'hidden';
                        idInput.name = `items[${idx}][id]`;
                        idInput.value = variantId;
                        this.main_product_form.appendChild(idInput);

                        const qtyInput = document.createElement('input');
                        qtyInput.type = 'hidden';
                        qtyInput.name = `items[${idx}][quantity]`;
                        qtyInput.value = '1';
                        this.main_product_form.appendChild(qtyInput);
                    }
                });
            }
        }
    }

    clearFormInputs() {
        const inputs = this.main_product_form.querySelectorAll('input[name^="items"]');
        inputs.forEach((input) => input.remove());
        const remaining = this.main_product_form.querySelectorAll('input[name^="items"]');
        if (remaining.length > 0) remaining.forEach((i) => i.remove());
    }

    clearVariantInputs() {
        this.clearFormInputs();
    }

    getSelectedQuantity() {
        return this.querySelector('.selected-quantity-break');
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.main_product_form;
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            if (text) addButtonText.textContent = text;
        }
        if (!modifyClass) return;
    }

    updateAddButtonState() {
        const selectedQuantityBreak = this.getSelectedQuantity();
        if (!selectedQuantityBreak) return;

        const buttonSpan = this.main_product_form.querySelector('[name="add"] > span');
        const originalATC = (typeof addToCartText !== 'undefined') ? addToCartText : 'Ajouter au panier';
        const preorderTxt = (typeof preorderButtonText !== 'undefined') ? preorderButtonText : originalATC;

        if (this.show_variant_picker) {
            const pickers = Array.from(selectedQuantityBreak.querySelectorAll('deployer-quantity-break-variant-picker'));
            const allAvailable = pickers.every((p) => p.dataset.available === 'true');
            const anyPreorder = pickers.some((p) => p.dataset.preorder === 'true');

            if (allAvailable || anyPreorder) {
                const text = anyPreorder ? preorderTxt : originalATC;
                if (buttonSpan) buttonSpan.dataset.defaultText = text;
                this.toggleAddButton(false, text, false);
            } else {
                this.toggleAddButton(true, theme.strings?.soldOut || 'Sold out', false);
            }
        } else {
            const variantId = selectedQuantityBreak.dataset.variantId;
            const variant = this.variantData.find(v => v.id == variantId);
            const variantIsPreorder = isVariantPreorder(variantId);

            if (variant && (variant.available || variantIsPreorder)) {
                const text = variantIsPreorder ? preorderTxt : originalATC;
                if (buttonSpan) buttonSpan.dataset.defaultText = text;
                this.toggleAddButton(false, text, false);
            } else {
                this.toggleAddButton(true, theme.strings?.soldOut || 'Épuisé', false);
            }
        }
    }

    updatePrice(quantity_break) {
        const productPriceContainer = document.querySelector('[data-product-price].product__price');
        if (!productPriceContainer) return;

        if (this.show_variant_picker === false) {
            const quantityBreakPriceElement = quantity_break.querySelector('.quantity-break_price-container_price');
            const quantityBreakComparePriceElement = quantity_break.querySelector('.quantity-break_price-container_compare-at-price');
            const customCompareAtPrice = quantity_break.dataset.customCompareAtPrice;

            // Check if custom compare at price is explicitly set to 0 (hide compare price)
            const hideComparePrice = customCompareAtPrice === '0' || customCompareAtPrice === 0;

            if (quantityBreakPriceElement) {
                const priceSpan = productPriceContainer.querySelector('span:not([data-product-compare-price])');
                if (priceSpan) {
                    priceSpan.innerHTML = quantityBreakPriceElement.innerHTML;
                }
            }

            // If custom compare at price is 0, don't show compare price
            if (hideComparePrice) {
                this.updateComparePrice(productPriceContainer, null);
            } else {
                this.updateComparePrice(productPriceContainer, quantityBreakComparePriceElement);
            }
        } else {
            this.updatePriceForSelectedVariants(quantity_break, productPriceContainer);
        }
    }

    initializeAllQuantityBreakPrices() {
        this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
            this.updatePriceForSelectedVariants(quantity_break, null);
        });
    }

    updatePriceForSelectedVariants(quantity_break, productPriceContainer) {
        const variantsPickers = quantity_break.querySelectorAll('deployer-quantity-break-variant-picker');
        if (variantsPickers.length === 0) return;

        const isInitialization = !productPriceContainer;

        const discountValue = quantity_break.dataset.discountValue;
        const discountPercentage = quantity_break.dataset.discountPercentage;
        // Correction: Si discount_on_total est vide ou "true", alors discountOnTotal = true
        const discountOnTotalStr = quantity_break.dataset.discountOnTotal || 'true';
        const discountOnTotal = discountOnTotalStr === 'true';
        const customCompareAtPrice = quantity_break.dataset.customCompareAtPrice;

        // Check if custom compare at price is explicitly set to 0 (hide compare price)
        const hideComparePrice = customCompareAtPrice === '0' || customCompareAtPrice === 0;

        const variantsWithPrices = [];
        variantsPickers.forEach((variantPicker) => {
            const variantId = variantPicker.dataset.id;
            const variant = this.variantData.find(v => v.id == variantId);
            if (variant) {
                const price = parseFloat(variant.price) / 100;
                const comparePrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) / 100 : price;
                variantsWithPrices.push({ variant, price, comparePrice });
            }
        });

        let finalPrice = 0;
        let finalComparePrice = 0;

        if (variantsWithPrices.length > 0) {
            if (discountOnTotal) {
                // Appliquer la réduction sur le prix total
                const totalPrice = variantsWithPrices.reduce((s, v) => s + v.price, 0);
                const totalCompare = variantsWithPrices.reduce((s, v) => s + v.comparePrice, 0);
                finalPrice = totalPrice;
                finalComparePrice = totalCompare;

                if (discountValue && discountValue !== '') {
                    const amount = parseFloat(String(discountValue).replace(',', '.'));
                    finalPrice = Math.max(0, totalPrice - amount);
                } else if (discountPercentage && discountPercentage !== '') {
                    const percent = parseFloat(String(discountPercentage).replace(',', '.'));
                    const discountAmount = (totalPrice * percent) / 100;
                    finalPrice = Math.max(0, totalPrice - discountAmount);
                }
            } else {
                // Appliquer la réduction uniquement sur l'article le moins cher
                variantsWithPrices.sort((a, b) => a.price - b.price);
                const lowest = variantsWithPrices[0];
                const others = variantsWithPrices.slice(1);

                let lowestPriceWithDiscount = lowest.price;

                if (discountValue && discountValue !== '') {
                    const amount = parseFloat(String(discountValue).replace(',', '.'));
                    lowestPriceWithDiscount = Math.max(0, lowest.price - amount);
                } else if (discountPercentage && discountPercentage !== '') {
                    const percent = parseFloat(String(discountPercentage).replace(',', '.'));
                    const discountAmount = (lowest.price * percent) / 100;
                    lowestPriceWithDiscount = Math.max(0, lowest.price - discountAmount);
                }

                // Prix final = prix de l'article le moins cher avec réduction + autres articles au prix normal
                finalPrice = lowestPriceWithDiscount + others.reduce((s, v) => s + v.price, 0);
                // Compare price reste le total original (sans réduction)
                finalComparePrice = variantsWithPrices.reduce((s, v) => s + v.comparePrice, 0);
            }
        }

        // Gérer le cas où finalComparePrice n'est pas défini
        if (finalComparePrice <= 0 || !finalComparePrice) {
            finalComparePrice = variantsWithPrices.reduce((s, v) => s + v.comparePrice, 0);
        }

        // If custom compare at price is 0, force hide compare price
        if (hideComparePrice) {
            finalComparePrice = finalPrice;
        }

        this.updateQuantityBreakPrice(quantity_break, finalPrice, finalComparePrice);
        if (!isInitialization && productPriceContainer) {
            this.updatePriceDisplay(productPriceContainer, finalPrice, finalComparePrice);
        }
    }

    updateQuantityBreakPrice(quantity_break, totalPrice, totalComparePrice) {
        const priceElement = quantity_break.querySelector('.quantity-break_price-container_price');
        if (priceElement) {
            priceElement.innerHTML = this.formatPrice(totalPrice);
        }

        const comparePriceElement = quantity_break.querySelector('.quantity-break_price-container_compare-at-price');
        if (comparePriceElement) {
            if (totalComparePrice > totalPrice) {
                comparePriceElement.innerHTML = this.formatPrice(totalComparePrice);
                comparePriceElement.style.display = 'block';
            } else {
                comparePriceElement.style.display = 'none';
            }
        }

        const savingsElement = quantity_break.querySelector('.quantity-break_price-container_savings');
        if (savingsElement && totalComparePrice > totalPrice) {
            const savings = totalComparePrice - totalPrice;
            const originalSavingsText = savingsElement.dataset.originalText;
            if (originalSavingsText) {
                const updatedSavingsText = originalSavingsText.replace('[savings]', this.formatPrice(savings));
                savingsElement.textContent = updatedSavingsText;
                savingsElement.style.display = 'block';
            }
        } else if (savingsElement) {
            savingsElement.style.display = 'none';
        }
    }

    updatePriceDisplay(productPriceContainer, totalPrice, totalComparePrice) {
        let priceSpan = productPriceContainer.querySelector('span:not([data-product-compare-price])');
        if (!priceSpan) {
            priceSpan = document.createElement('span');
            productPriceContainer.appendChild(priceSpan);
        }
        priceSpan.innerHTML = this.formatPrice(totalPrice);

        if (totalComparePrice > totalPrice) {
            let comparePriceSpan = productPriceContainer.querySelector('span[data-product-compare-price]');
            if (!comparePriceSpan) {
                comparePriceSpan = document.createElement('span');
                comparePriceSpan.setAttribute('data-product-compare-price', '');
                productPriceContainer.appendChild(comparePriceSpan);
            }
            comparePriceSpan.innerHTML = this.formatPrice(totalComparePrice);
        } else {
            const comparePriceSpan = productPriceContainer.querySelector('span[data-product-compare-price]');
            if (comparePriceSpan) comparePriceSpan.remove();
        }
    }

    updateComparePrice(productPriceContainer, quantityBreakComparePriceElement) {
        let comparePriceSpan = productPriceContainer.querySelector('span[data-product-compare-price]');
        if (quantityBreakComparePriceElement) {
            if (comparePriceSpan) {
                comparePriceSpan.innerHTML = quantityBreakComparePriceElement.innerHTML;
            } else {
                comparePriceSpan = document.createElement('span');
                comparePriceSpan.setAttribute('data-product-compare-price', '');
                comparePriceSpan.innerHTML = quantityBreakComparePriceElement.innerHTML;
                productPriceContainer.appendChild(comparePriceSpan);
            }
        } else if (comparePriceSpan) {
            comparePriceSpan.remove();
        }
    }

    formatPrice(price) {
        // Utiliser le format de devise Shopify actuel basé sur le marché
        const shopCurrency = window.Shopify?.currency?.active || 'EUR';
        const shopLocale = document.documentElement.lang || 'fr-FR';
        
        // Fallback : si le thème utilise déjà Shopify.formatMoney
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            // Convertir le prix en centimes pour formatMoney
            return Shopify.formatMoney(price * 100, theme.moneyFormat || window.theme?.moneyFormat);
        }
        
        return new Intl.NumberFormat(shopLocale, {
            style: 'currency',
            currency: shopCurrency
        }).format(price);
    }
}

customElements.define('deployer-quantity-breaks', DeployerQuantityBreaks);

class QuantityBreakVariantPicker extends HTMLElement {
    constructor() {
        super();
        this.DeployerQuantityBreaks = document.querySelector('deployer-quantity-breaks');
        this.inputs = this.querySelectorAll('input[type="radio"]');
        this.selects = this.querySelectorAll('select');
        this.optionsNames = this.querySelectorAll('legend span');
        this.options = [];
        this.currentVariant = this.dataset.id;
        this.variantData = variantData;
        this.isInitializing = true;
    }

    connectedCallback() {
        this.updateOptions();
        this.updateVariantStatuses();
        this.initializeSelects();

        this.inputs.forEach((input) => {
            input.addEventListener('change', (event) => {
                this.onChange(event);
            });
        });
        this.selects.forEach((select) => {
            select.addEventListener('change', (event) => {
                this.onChange(event);
            });
        });

        setTimeout(() => {
            const deployerQuantityBreaks = this.closest('deployer-quantity-breaks');
            if (deployerQuantityBreaks) {
                const selectedQuantityBreak = deployerQuantityBreaks.getSelectedQuantity();
                if (selectedQuantityBreak) {
                    deployerQuantityBreaks.updatePrice(selectedQuantityBreak);
                }
            }
        }, 100);
    }

    initializeSelects() {
        const defaultVariantId = this.dataset.id;
        const defaultVariant = this.variantData.find(v => v.id == defaultVariantId);
        
        if (defaultVariant) {
            this.selects.forEach((select) => {
                const optionPosition = select.closest('fieldset').dataset.optionPosition;
                if (optionPosition) {
                    const optionValue = defaultVariant[`option${optionPosition}`];
                    if (optionValue) {
                        select.value = optionValue;
                    }
                }
            });
            
            this.inputs.forEach((input) => {
                const fieldset = input.closest('fieldset');
                const optionPosition = fieldset.dataset.optionPosition;
                if (optionPosition) {
                    const optionValue = defaultVariant[`option${optionPosition}`];
                    if (optionValue && input.value === optionValue) {
                        input.checked = true;
                    }
                }
            });
            
            this.onChange();
        }
    }

    onChange() {
        this.updateOptions();
        this.updateDataId();
        this.updateOptionsNames();
        this.updateVariantStatuses();
        this.updateImages();

        if (this.isInitializing) {
            this.isInitializing = false;
            return;
        }

        const productContainer = this.closest('.product-section');
        if (productContainer) {
            productContainer.dispatchEvent(new CustomEvent('variantImageChange', {
                detail: {
                    variant: this.currentVariant
                }
            }));
        }

        const deployerQuantityBreaks = this.closest('deployer-quantity-breaks');
        if (deployerQuantityBreaks) {
            const selectedQuantityBreak = deployerQuantityBreaks.getSelectedQuantity();
            if (selectedQuantityBreak) {
                deployerQuantityBreaks.updatePrice(selectedQuantityBreak);
                deployerQuantityBreaks.updateAddButtonState();
            }
        }

        this.dispatchEvent(new CustomEvent('variantChange', {
            detail: {
                variant: this.currentVariant
            }
        }));
    }

    updateOptions() {
        this.options = [];
        this.options.push(
            ...Array.from(this.querySelectorAll('input[type="radio"]:checked'), (element) => {
                if (element.tagName === 'INPUT') {
                    return element.value;
                }
            })
        );
        this.options.push(
            ...Array.from(this.querySelectorAll('select'), (element) => {
                if (element.tagName === 'SELECT') {
                    return element.value;
                }
            })
        );
    }

    updateDataId() {
        this.currentVariant = this.variantData.find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
        this.dataset.id = this.currentVariant.id;

        if (this.currentVariant.available === false) {
            this.dataset.available = 'false';
        } else {
            this.dataset.available = 'true';
        }

        this.dataset.preorder = isVariantPreorder(this.currentVariant.id) ? 'true' : 'false';
    }

    updateVariantStatuses() {
        const selectedOptions = this.querySelectorAll(':checked');
        const inputWrappers = [...this.querySelectorAll('fieldset')];
        let selectedOptionOneVariants = null;
        let selectedOptionTwoVariants = null;
        let selectedOptionThreeVariants = null;
        if (selectedOptions[0]) {
            selectedOptionOneVariants = this.variantData.filter((variant) => selectedOptions[0].value === variant.options[0]);
        }
        if (selectedOptions[1]) {
            selectedOptionTwoVariants = this.variantData.filter((variant) => selectedOptions[1].value === variant.options[1]);
        }
        if (selectedOptions[2]) {
            selectedOptionThreeVariants = this.variantData.filter((variant) => selectedOptions[2].value === variant.options[2]);
        }
        inputWrappers.forEach((option, index) => {
            if (selectedOptions.length <= 1) return;
            if (index === 0) {
                const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
                const previousOptionSelected = inputWrappers[index + 1].querySelector(':checked').value;
                const availableOptionInputsValue = selectedOptionTwoVariants.filter((variant) => variant.available && variant.options[index + 1] === previousOptionSelected).map((variantOption) => variantOption.options[index]);
                this.setInputAvailability(optionInputs, availableOptionInputsValue);
            } else {
                const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
                const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
                const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant.options[index - 1] === previousOptionSelected).map((variantOption) => variantOption.options[index]);
                this.setInputAvailability(optionInputs, availableOptionInputsValue);
            }
        });
    }

    setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);

            if (element.tagName === 'INPUT') {
                if (availableElement) {
                    element.classList.remove('disabled');
                } else {
                    element.classList.add('disabled');
                }
            } else if (element.tagName === 'OPTION') {
                if (availableElement) {
                    element.disabled = false;
                    element.classList.remove('disabled');
                } else {
                    element.disabled = true;
                    element.classList.add('disabled');
                }
            }
        });
    }

    updateImages() {
        const variant = this.variantData.filter((variant) => {
            return variant.id === this.currentVariant.id;
        });

        const transparentImage = this.getTransparentImage(this.currentVariant.id);

        if (transparentImage) {
            this.setImage(transparentImage);
        } else if (variant[0]?.featured_image?.src) {
            this.setImage(variant[0].featured_image.src);
        }
    }

    setImage(imageUrl) {
        const quantityBreakMainContent = this.closest('.quantity-break_main-content');
        const images = quantityBreakMainContent.querySelectorAll('img');
        const index = Number.parseInt(this.dataset.index) - 1;
        const image = images[index];

        image.src = imageUrl;
    }

    getTransparentImage(variantId) {
        const transparentImage = transparentImages.find((variant) => variant.id === variantId);
        return transparentImage?.transparentImage;
    }

    updateOptionsNames() {
        this.optionsNames.forEach((optionName, index) => {
            optionName.innerText = this.options[index];
        });
    }
}
customElements.define('deployer-quantity-break-variant-picker', QuantityBreakVariantPicker);
